// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

export type ToastState = {
    showToastMessage: boolean;
};

const initialState: ToastState = {
    showToastMessage: false,
};

const reducer = {
    "Toast/Show": (draft: Draft<ToastState>) => {
        draft.showToastMessage = true;
    },
    "Toast/Hide": (draft: Draft<ToastState>) => {
        draft.showToastMessage = false;
    },
};

const xToast = createTypedReducerWithImmer(initialState, reducer);

(reducers as any).xToast = xToast;

export type xToastState = {
    xToast: ToastState;
} & ApplicationState;

type ToastReducers = {
    [key: string]: typeof xToast;
};

export type xToastAction =
    | Parameters<ToastReducers[keyof ToastReducers]>[1]
    | AnyAction;
